import { TextInput } from "carbon-components-react"
import styled from 'styled-components';

const selectStyles = (props) => {
  let isDirty = null
  if (props?.isDirty) isDirty = props.isDirty
  return {
    control: (styles, { isFocused }) => ({
      ...styles,
      backgroundColor: isDirty ? '#e6f7ff' : '#f4f4f4',
      border: 0,
      borderBottom: isFocused ? 'none' : '1px solid #8d8d8d',
      boxShadow: isFocused ? 'none' : 'none',
      outline: isFocused ? '2px solid #52B9D1' : 'none',
      outlineOffset: '-2px',
    }),
    option: (styles, { data, isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected ? '#52B9D1' : isFocused ? '#e6f7ff' : data.color,
      ':active': {
        ...styles[':active'],
        backgroundColor: '#52B9D1',
      },
    }),
    multiValue: (styles) => ({
      ...styles, backgroundColor: '#d9d9d9',
    }),
  }
}

/**
 * Transform React Select options format: { value, label }
 * to server conventions:
 * * if multi-select, to object in format: { id, name }
 * * if single-select, to string.
 * @param {Object} selectedItems React Select 1st param
 * @param {Object} evtObject React Select 2nd param
 * @returns object/string expected on server
 */
const getSelectValuesToSubmit = (selectedItems, evtObject) => {
  if (!selectedItems) return null
  if (evtObject.name) {
    if (Array.isArray(selectedItems)) {
      return selectedItems.map((item) => ({ id: item.value, name: item.label }))
      // TODO: only send id in object?
      return selectedItems.map((item) => ({ id: item.value }))
    } else {
      return selectedItems.label
    }
  } else {
    console.error('ERROR: select field name is not defined. The value will cannot be saved!')
  }
  return null
}

const getValuesForReactSelect = (serverValues, options) => {
  if (serverValues) {
    if (Array.isArray(serverValues)) {
      if (serverValues.length === 0) return null;
      return serverValues.map((item) => ({ value: item.id, label: item.name }))
    }
    if (typeof serverValues === 'string' && options?.length > 0) {
      // return array with one item
      return options.reduce((acc, item) => {
        if (item.label === serverValues) acc.push(item)
        return acc
      }, [])
      // or return one object item?
      return options.find((item) => item.label === serverValues)
    }
  }
  return null
}

const formatReadOnlyField = (label, value) => {
  return <TextInput
    labelText={label}
    size="sm"
    id=""
    value={value}
    readOnly={true}
    onFocus={(evt) => evt.target.select()}
  />
}

const formatReadOnlyStudyId = (value) => {
  return <ReadOnlyStudyIdStyled>
    {formatReadOnlyField('Study ID', value)}
  </ReadOnlyStudyIdStyled>
}

const ReadOnlyStudyIdStyled = styled.div`
  .bx--text-input[readonly], .bx--text-area[readonly] {
    font-weight: bold;
    font-size: 1.2em;
    color: #666666;
  }
`

export {
  selectStyles,
  getSelectValuesToSubmit,
  getValuesForReactSelect,
  formatReadOnlyField,
  formatReadOnlyStudyId,
}